import { Ping, setBalance, setNotifications } from "../store/slices/userSlice";
import UseEvent from "./useEvent";
import { Api, i18n } from "../index";
import { useDispatch, useSelector } from "react-redux";
import Config from '../config/config';

function UseUser() {
  const dispatch = useDispatch();
  const ev = UseEvent();
  const User = useSelector((state) => state?.User);

  const keepAlive = async (loader=null, lang = i18n.language) => {
    const response = await Api.Guest.Ping(loader, lang);
    window.isLogged = response.status;
    window.is_loged = response.status;
    window.user = response.status ? response.data : null;
    if (response.status) {
      await updateBalance(false);

      if(response.data?.['post_aff_show_first_dep']){
        Api.Payments.firstDeposit({url: Config.Payment.deposit.CheckFirst, loader}).then(res => {
          if(res.status && res.data){
            Api.Payments.firstDeposit({url: Config.Payment.deposit.ClearFirst, loader}).then(res => {
              if(res.status && window.trackLeaderBet) window.trackLeaderBet("FirstDeposit");
            })
          }
        })
      }
    }
    ev.emit("user", { isLogged: response.status, data: response.data });
    window.User = { isLogged: response.status, data: response.data };

    return response;
  };
  const Alive = () =>{
    Api.Guest.Alive();
  }
  const setUserData = ({ isLogged, data }) => {
    dispatch(Ping({ isLogged: isLogged, data: data }));
  };
  const setUserBalance = (balance) => {
    dispatch(setBalance(balance));
  };
  const updateBalance = async (mainOnly = true) => {
    if (mainOnly) {
      const response = await Api.User.MainBalance();
      ev.emit("balance", {
        gel: response?.data?.deposit?.deposit || 0,
      });
      window.User = {
        ...window.User || {},
        balance: {
          gel: response?.data?.deposit?.deposit || 0,
        }
      }
      return {
        ...response,
        data: { data: { gel: response?.data?.deposit?.deposit || 0 } },
      };
    } else {
      const response = await Api.User.Balance();
      ev.emit("balance", response.data.data);
      window.User = {...window.User || {}, balance: response.data.data}
      return response;
    }
  };
  const setUserNotifications = (data) => {
    dispatch(setNotifications(data));
  };
  const updateNotifications = async () => {
    const response = await Api.User.Notifications.unread();

    window.User = {
      ...window.User || {},
      notifications: response.data.data,
    }
    ev.emit("notifications", response.data.data);
    return response;
  };
  const logout = () => {
    return new Promise((resolve) => {
      Api.User.Logout().then((response) => {
        if (response.status) {
          window.isLogged = false;
          window.is_loged = false;
          window.user = false;
          ev.emit("notifications", 0);
          ev.emit("balance", {
            points: 0,
            balance: 0,
            cashbackLevel: 0,
            levelPoints: 0,
          });
          ev.emit("user", { isLogged: false, data: null });
          window.User = { isLogged: false, data: null };
          window.location.href="/"+i18n.language;
          resolve(true);

        }
      });
    });
  };
  return {
    User,
    keepAlive,
    setUserData,
    updateBalance,
    setUserBalance,
    updateNotifications,
    setUserNotifications,
    logout,
    Alive
  };
}

export default UseUser;
